var _circle, _circle2, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 74.5,
    r: 74.5,
    fill: "#359943",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 74.5,
    r: 58.752,
    fill: "#359943",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    x: 32.5,
    y: 33,
    fill: "#359943",
    rx: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.864,
    d: "M74.5 94.091c10.5 0 19.091-8.59 19.091-19.09s-8.59-19.092-19.09-19.092S55.408 64.5 55.408 75C55.41 85.5 64 94.091 74.5 94.091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.864,
    d: "m66.386 75 5.403 5.402 10.825-10.805"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycSuccess);
export default __webpack_public_path__ + "static/media/kycSuccess.ce4b8efc148e16cbe72b1e2727681bf8.svg";
export { ForwardRef as ReactComponent };